@if (!loading) {
  <div>
    @if (sections?.length) {
      <cotecna-nf-form
        #naturalForm
        [config]="formConfig"
        [sections]="sections"
        [controls]="controls"
        >
      </cotecna-nf-form>
    } @else {
      <div id="empty-sow">
        <mat-icon>sentiment_dissatisfied</mat-icon>
        There is no scope of work available yet.
      </div>
    }

  </div>
}
